import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'Location',
})(({ brandColors, type, spacing, typography: { pxToRem } }, props) => ({
  location: {
    background: brandColors.offWhite,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  locationInner: {
    position: 'absolute',
    inset: spacing(2),
  },
  locationDark: {
    background: brandColors.tintsHeroBlue10,
    color: brandColors.white,
  },
  locationTitle: {
    ...type['18_medium'],
    textWrap: 'pretty',
    textAlign: 'center',
    margin: `${pxToRem(66)} ${pxToRem(24)} ${pxToRem(24)} ${pxToRem(24)}`,
  },
  backText: {
    ...type['16_medium'],
    color: brandColors.mediumBlue,
    padding: spacing(1),
    borderBottom: '1px solid var(--line, rgba(0, 0, 0, 0.20))',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& svg': {
      display: 'none',
    },
    '&:hover svg': {
      display: 'inline',
      marginRight: 0,
    },
    '& a': {
      textDecoration: 'none',
    },
    '&:hover': {
      borderBottom: `2px solid ${brandColors.primaryMain}`,
      marginBottom: '-1px',
      color: brandColors.primaryMain,
    },
  },
  backTextDark: {
    '&:hover': {
      borderBottom: `2px solid ${brandColors.white}`,
    },
    '&:hover svg': {
      color: brandColors.white,
    },
  },
  inputWrapper: {
    '& input': {
      marginTop: pxToRem(4),
      background: 'none',
      border: `1px solid ${brandColors.tintsNeutral30}`,
    },
    paddingBottom: pxToRem(20),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    '& button': {
      width: '100%',
      margin: `${spacing(1)} 0`,
    },
  },
  lineContainer: {
    display: 'flex',
    alignItems: 'center',
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  line: {
    flexGrow: 1,
    height: '1px',
    backgroundColor: darkOrLightStyle(props)(
      brandColors.white,
      brandColors.primaryMain
    ),
    margin: `0 ${pxToRem(10)}`,
  },
}));

export default useStyles;
